module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAArUlEQVQ4y2NgGBxgqvN/0yqr/8f1lf7fUZGHYxhAFgOpAakF6YHr7/fW+c85wfG/eKf9/1V26jgNAMmB1IDUgvTADQBJbrVQ/a/QavefZbLT/4ZgPQwDGoFirJOcwGpAakFiKAaA8Dltxf9OxRZg5wVmm8ENALFBYiA5kBqYegwDQPg2EBdGG/5nmuIMNwDEzo8xBMshq4Ub8J9MQD0XUCUMKIoFitMBxSlxaAMAJl15zN6azj8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_basque-country.png
// module id = 1309
// module chunks = 0